<template>
  <div class="cabinet-blank">
    <main>
      <b-container fluid class="px-3 py-0" id="content">
        <router-view />
      </b-container>
    </main>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

// Порожній лояут кабінету: без шапки і футера — кабінет займає всю сторінку,
// зверху лишається тільки тонка смуга з мовою та кнопками самого кабінету.
// Вмикається для сідів зі списку sidsFullscreenCabinet (@/config/configuration).
@Component
export default class CabinetBlankTemplate extends Vue {}
</script>

<style lang="scss">
.cabinet-blank {
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  main {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
  }

  // кнопки кабінету — тонкою смугою, портальної шапки тут немає
  #content > div:last-child {
    padding-top: 0.25rem !important;
    padding-bottom: 0 !important;

    // ряд кнопок має різний mb для ролей (mb-1 / mb-3) — вирівнюємо під верхній відступ
    > .row {
      margin-bottom: 0.25rem !important;
    }
  }

  // перемикач мов стоїть у тому ж рядку, що й кнопки: у шапці він світлий,
  // з великими паддінгами і підкресленням — тут підганяємо під btn-sm поруч
  .language-dropdown {
    color: var(--portal-primary) !important;
    border-bottom: 0 !important;
    padding: 0.25rem 0.5rem !important;
    font-size: 0.875rem;
    line-height: 1.5;
  }
}
</style>
